import { render } from "./ControlBar.vue?vue&type=template&id=d3c5dd7e&scoped=true"
import script from "./ControlBar.vue?vue&type=script&lang=js"
export * from "./ControlBar.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-d3c5dd7e"

export default script